import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../creators/assets/images/file.png'
import _imports_1 from '../assets/images/link.png'


const _withScopeId = n => (_pushScopeId("data-v-07a61fd3"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "p-grid p-col-12 p-mt-6 p-flex-wrap",
  style: {"width":"100%"}
}
const _hoisted_2 = { class: "p-col-12 p-lg-3" }
const _hoisted_3 = { class: "p-d-flex p-flex-wrap navigations p-ai-center" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "search", -1))
const _hoisted_6 = { class: "p-input-icon-left w-100" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_8 = { class: "all-notifications" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "p-d-flex p-mb-4"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "p-d-flex p-flex-column message" }
const _hoisted_13 = { class: "notification" }
const _hoisted_14 = {
  key: 0,
  class: "msg-item"
}
const _hoisted_15 = { class: "date p-d-flex p-justify-start" }
const _hoisted_16 = { class: "p-mt-2" }
const _hoisted_17 = {
  key: 0,
  class: "p-grid p-col-12 p-d-flex p-flex-column"
}
const _hoisted_18 = {
  key: 1,
  class: "p-col-12 p-lg-8 p-ml-6"
}
const _hoisted_19 = {
  key: 0,
  class: "main-item-title"
}
const _hoisted_20 = { class: "p-col-5 p-lg-4 p-d-flex p-ai-center" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-img-file" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_22 = { class: "p-pl-4" }
const _hoisted_23 = { class: "p-text-bold number-contract eclipsis" }
const _hoisted_24 = { class: "p-d-flex" }
const _hoisted_25 = {
  key: 0,
  class: "approved p-mr-3"
}
const _hoisted_26 = { class: "p-mr-6" }
const _hoisted_27 = {
  key: 0,
  class: "link"
}
const _hoisted_28 = { class: "link-bold eclipsis" }
const _hoisted_29 = { class: "p-ml-6" }
const _hoisted_30 = {
  key: 0,
  class: "inf-block"
}
const _hoisted_31 = ["src"]
const _hoisted_32 = { style: {"color":"#162020","font-weight":"600"} }
const _hoisted_33 = { class: "date" }
const _hoisted_34 = {
  key: 1,
  class: "inf-block"
}
const _hoisted_35 = ["src"]
const _hoisted_36 = { style: {"color":"#162020","font-weight":"600"} }
const _hoisted_37 = { class: "date" }
const _hoisted_38 = { class: "content" }
const _hoisted_39 = {
  key: 0,
  class: "link"
}
const _hoisted_40 = { class: "link-bold eclipsis" }
const _hoisted_41 = {
  key: 1,
  class: "approved p-mr-3"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hr p-mt-5" }, null, -1))
const _hoisted_43 = {
  key: 0,
  class: "p-mt-5"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Submission", -1))
const _hoisted_45 = { class: "p-d-flex p-ai-center" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-link" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "comment", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_inboxNotifications = _resolveComponent("inboxNotifications")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.activeNav = 0)),
          class: _normalizeClass([$setup.activeNav === 0 ? 'active-tab' : ''])
        }, "Messages", 2),
        _createElementVNode("span", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.activeNav = 1)),
          class: _normalizeClass([$setup.activeNav === 1 ? 'active-tab' : ''])
        }, "Notifications", 2)
      ]),
      ($setup.activeNav === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("span", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_InputText, {
                type: "text",
                modelValue: $setup.searchInput,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.searchInput) = $event)),
                placeholder: "Search for Campaign, Contract or Client"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.contracts, (i, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "p-d-flex p-flex-column notification-block",
                  key: `${idx}_msg`
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(i?.contracts[0]?.deliverables, (o, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "p-d-flex msg-item",
                      key: `${index}_msg`,
                      onClick: ($event: any) => ($setup.getActiveMessageData(i?.contracts[0], idx, index, i?.id)),
                      style: _normalizeStyle($setup.activeMessageIndex === idx && $setup.activeDeliverableIndex === index ? 'filter: opacity(100%);' : '')
                    }, [
                      (o?.links[0]?.comments[o?.links[0]?.comments.length - 1]?.from === 'brand')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createElementVNode("img", {
                              src: i?.photo,
                              class: "notification-img"
                            }, null, 8, _hoisted_11),
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("span", _hoisted_13, [
                                _createTextVNode(_toDisplayString(i?.name) + ": ", 1),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(o?.links[0]?.comments, (c) => {
                                  return (_openBlock(), _createElementBlock("span", { key: c }, [
                                    (c?.from === 'brand')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                                          _createTextVNode(_toDisplayString(c?.text), 1),
                                          _createElementVNode("span", _hoisted_15, [
                                            _createElementVNode("span", _hoisted_16, _toDisplayString($setup.timeAgo(c?.createdAt)), 1)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 12, _hoisted_9))
                  }), 128))
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    ($setup.activeNav === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createVNode(_component_inboxNotifications)
        ]))
      : _createCommentVNode("", true),
    ($setup.activeNav === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          ($setup.contract)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("span", _hoisted_23, "#" + _toDisplayString($setup.contract?.contracts[0]?.id), 1)
                  ])
                ]),
                _createElementVNode("span", _hoisted_24, [
                  ($setup.contract?.contracts[0]?.deliverables[$setup.activeDeliverableIndex])
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["status", $setup.contract?.contracts[0]?.deliverables[$setup.activeDeliverableIndex]?.status])
                        }, null, 2),
                        _createTextVNode(_toDisplayString($setup.contract?.contracts[0]?.deliverables[$setup.activeDeliverableIndex]?.status === 'rejected' ? 'Change requested' :
                  $setup.contract?.contracts[0]?.deliverables[$setup.activeDeliverableIndex]?.status), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_26, _toDisplayString($setup.timeAgo($setup.contract?.contracts[0]?.deliverables[$setup.activeDeliverableIndex]?.updatedAt) || '- -'), 1)
                ]),
                _createElementVNode("div", null, [
                  ($setup.contract?.contracts[0]?.deliverables[$setup.activeDeliverableIndex]
          ?.links[$setup.contract?.contracts[0]?.deliverables[$setup.activeDeliverableIndex]?.links.length - 1]?.link)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _createElementVNode("span", _hoisted_28, _toDisplayString($setup.contract?.contracts[0]?.deliverables[$setup.activeDeliverableIndex]?.links
                      [$setup.contract?.contracts[0]?.deliverables[$setup.activeDeliverableIndex]?.links.length - 1]?.link), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.contract?.contracts[0]?.deliverables[$setup.activeDeliverableIndex]?.links, (item, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: `${index}bv`
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item?.comments, (comment, idx) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: `${idx}_com`
                    }, [
                      (comment?.from === 'brand')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            _createElementVNode("img", {
                              src: $setup.contract?.photo,
                              class: "inf-img"
                            }, null, 8, _hoisted_31),
                            _createElementVNode("span", _hoisted_32, _toDisplayString($setup.contract?.name), 1),
                            _createElementVNode("span", _hoisted_33, _toDisplayString($setup.formatDate(comment?.updatedAt, 'long')), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (comment?.from === 'creator')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                            _createElementVNode("img", {
                              src: $setup.contract?.contracts[0]?.creator?.profile?.photo,
                              class: "inf-img"
                            }, null, 8, _hoisted_35),
                            _createElementVNode("span", _hoisted_36, _toDisplayString($setup.contract?.contracts[0]?.creator?.name), 1),
                            _createElementVNode("span", _hoisted_37, _toDisplayString($setup.formatDate(comment?.updatedAt, 'long')), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_38, [
                        (comment?.from === 'creator')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                              _createElementVNode("span", _hoisted_40, _toDisplayString(item?.link), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (comment?.from === 'brand')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["status", item?.status])
                              }, null, 2),
                              _createTextVNode(" " + _toDisplayString(item?.status === 'rejected' ? 'Change requested' : item?.status === 'accepted' ? 'Accepted'
                        : item?.status === 'updated' ? 'Change requested' : ''), 1)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("p", null, _toDisplayString(comment?.text), 1)
                      ]),
                      _hoisted_42
                    ], 64))
                  }), 128))
                ], 64))
              }), 128))
            ]),
            ($props.viewPerspective === 'creator' && $setup.contract)
              ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                  _hoisted_44,
                  _createElementVNode("div", _hoisted_45, [
                    _hoisted_46,
                    _createVNode(_component_InputText, {
                      type: "text",
                      modelValue: $setup.link,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.link) = $event)),
                      placeholder: "Enter submissions link",
                      class: "w-100 p-p-2",
                      disabled: $setup.contract?.contracts[0]?.deliverables[$setup.activeDeliverableIndex]?.status === 'pending'
            || $setup.contract?.contracts[0]?.deliverables[$setup.activeDeliverableIndex]?.status === 'accepted',
                      onKeydown: _cache[4] || (_cache[4] = _withKeys(($event: any) => ($setup.sendLinkAndComment($setup.contract?.contracts[0]?.deliverables[$setup.activeDeliverableIndex].id)), ["enter"]))
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _hoisted_47,
                  _createVNode(_component_Textarea, {
                    modelValue: $setup.commentTextarea,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.commentTextarea) = $event)),
                    placeholder: "Type comment here...",
                    rows: "8",
                    class: "w-100 p-p-3",
                    style: {"resize":"none"},
                    disabled: $setup.contract?.contracts[0]?.deliverables[$setup.activeDeliverableIndex]?.status === 'pending'
                    || $setup.contract?.contracts[0]?.deliverables[$setup.activeDeliverableIndex]?.status === 'accepted',
                    onKeydown: _cache[6] || (_cache[6] = _withKeys(($event: any) => ($setup.sendLinkAndComment($setup.contract?.contracts[0]?.deliverables[$setup.activeDeliverableIndex]?.id)), ["enter"]))
                  }, null, 8, ["modelValue", "disabled"]),
                  _createVNode(_component_Button, {
                    label: "reSubmit content",
                    class: "red-button p-mt-5",
                    disabled: $setup.contract?.contracts[0]?.deliverables[$setup.activeDeliverableIndex]?.status === 'pending'
                  || $setup.contract?.contracts[0]?.deliverables[$setup.activeDeliverableIndex]?.status === 'accepted',
                    onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.sendLinkAndComment($setup.contract?.contracts[0]?.deliverables[$setup.activeDeliverableIndex].id)))
                  }, null, 8, ["disabled"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}